module.exports = __webpack_public_path__ + "img/5-1.ebeab2f0.jpg";